import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Alert, Form, Button, Row, Col, ControlLabel } from 'react-bootstrap';
import { Input, FormActions, Radio, Checkbox, MultiSelect } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const min1 = validators.minValue(1);
const min0 = validators.minValue(0);
const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, instalmentIntervalTypes, intervalLength,
	intervalType, instalmentStart, usageTypes, offerIndividualConsultations, offerWorkshops, weekDays, daysOfMonth, isRestrictedUser, t }) => {

	const instalmentStartOptions = [
		{ value: '1', label: t('InstalmentPlanTemplate_CollectAfterBooking') },
		{ value: '2', label: intervalType == 1 ? t('InstalmentPlanTemplate_CollectOnSpecificDayOfWeek') : t('InstalmentPlanTemplate_CollectOnSpecificDayOfMonth') },
		{ value: '3', label: t('InstalmentPlanTemplate_CollectOnFirstLessonDate') }
	];
	// the form field yields a string and i18next skips plural handling for a string count
	const intervalCount = Number(intervalLength);
	const intervalTypeString = t(intervalType == 1 ? 'InstalmentPlanTemplate_Weeks' : 'InstalmentPlanTemplate_Months', { count: intervalCount });
	const instalmentStartHelpText = instalmentStart == 1 ?
		t('InstalmentPlanTemplate_CollectAfterBookingHelpText', { intervalLength: intervalLength, intervalType: intervalTypeString }) :
		(instalmentStart == 2 ? t('InstalmentPlanTemplate_CollectOnSpecificDayHelpText') : t('InstalmentPlanTemplate_CollectOnFirstLessonDateHelpText',
			{ intervalLength: intervalLength, intervalType: intervalTypeString }));

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} disabled={isReadonly} horizontal required type='text' label={t('InstalmentPlanTemplate_Name')} validate={[validators.required]} />
			<CentersDropdownList render='field' name='centerId' horizontal disabled={isReadonly} label={t('InstalmentPlanTemplate_Center')} emptyLabel={isRestrictedUser ? '' : t('InstalmentPlanTemplate_AllCenters')} />
			<Field name='totalPayments' component={Input} disabled={isReadonly} horizontal required type='text' label={t('InstalmentPlanTemplate_TotalPayments')} validate={[validators.required, validators.integer, min1]} />
			<Field name='depositPayments' component={Input} disabled={isReadonly} required horizontal type='text' label={t('InstalmentPlanTemplate_CollectDeposit')} addon={t('InstalmentPlanTemplate_DepositPayments_Addon')} validate={[validators.required, validators.integer, min0]} />
			<Row>
				<Col componentClass={ControlLabel} sm={2}>
					{t('InstalmentPlanTemplate_IntervalLength')} <em className='required_s'>*</em>
				</Col>
				<Col sm={1}>
					<Field name='intervalLength' component={Input} disabled={isReadonly} horizontal labelCol={0} type='text' validate={[validators.required, validators.integer, min1]} />
				</Col>
				<Col sm={3}>
					<Field name='intervalType' component={Input} disabled={isReadonly} componentClass='select' labelCol={0} horizontal validate={validators.required}>
						{ui.makeOptionValues(instalmentIntervalTypes)}
					</Field>
				</Col>
			</Row>
			<Field name='instalmentStart' component={Radio} entries={instalmentStartOptions} disabled={isReadonly}
				help={instalmentStartHelpText} label={t('InstalmentPlanTemplate_InstalmentStart')} horizontal inline required />
			{instalmentStart == 2 && intervalType == 1 && <Field name='dayOfWeek' required horizontal component={Input} disabled={isReadonly} componentClass='select' label={t('InstalmentPlanTemplate_On_WeekDay')} addon={t('InstalmentPlanTemplate_DayOfWeek', { count: intervalCount })} validate={[validators.required]} >
				<option />
				{weekDays.map(day => <option key={day} value={day}>{t(ui.days[day])}</option>)}
			</Field>}
			{instalmentStart == 2 && intervalType == 2 && <Field name='dayOfMonth' required horizontal disabled={isReadonly} component={Input} componentClass='select' label={t('InstalmentPlanTemplate_On')} addon={t('InstalmentPlanTemplate_DayOfMonth')} validate={[validators.required]} >
				<option />
				{ui.makeOptionValues(daysOfMonth)}
			</Field>}
			{(offerIndividualConsultations || offerWorkshops) && <Field name='usageType' horizontal required component={MultiSelect} options={usageTypes} label={t('InstalmentPlanTemplate_UsageType')} validate={[validators.requiredArray]} />}
			<Field name='minLessonCount' component={Input} disabled={isReadonly} horizontal type='text' label={t('InstalmentPlanTemplate_MinLessonCount')} validate={[validators.integer]} />
			<Field name='maxLessonCount' component={Input} disabled={isReadonly} horizontal type='text' label={t('InstalmentPlanTemplate_MaxLessonCount')} validate={[validators.integer, min0]} />
			<Field name='minOrderAmount' component={Input} disabled={isReadonly} horizontal type='text' label={t('InstalmentPlanTemplate_MinOrderAmount')} validate={[validators.number]} />
			<Field name='enabled' component={Checkbox} horizontal disabled={isReadonly} label={t('InstalmentPlanTemplate_Enabled')} normalize={(v) => { return !!v }} />

			<FormActions horizontal>
				<Link to='/instalmentPlans' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'instalmentPlanTemplate', enableReinitialize: true })(withTranslation()(SettingsForm));

export const selector = formValueSelector('instalmentPlanTemplate');